const Close = ({ onClick, fill, className }: { onClick: () => void; fill?: string; className?: string }) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 512 512"
    >
      <path
        d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
        fill="none"
        stroke={fill || "#000"}
        strokeMiterlimit="10"
        strokeWidth="32px"
      />
      <line
        x1="320"
        y1="320"
        x2="192"
        y2="192"
        fill="none"
        stroke={fill || "#000"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32px"
      />
      <line
        x1="192"
        y1="320"
        x2="320"
        y2="192"
        fill="none"
        stroke={fill || "#000"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32px"
      />
    </svg>
  );
};

export default Close;
